var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,23a11.13,11.13,0,0,1-7.89-3.23A11.6,11.6,0,0,1,0,11.7,11.3,11.3,0,0,1,3.33,3.51,11.72,11.72,0,0,1,11.49,0a11.19,11.19,0,0,1,8.1,3.23A11.57,11.57,0,0,1,11.51,23Zm.4-22h-.19A10.73,10.73,0,0,0,4,4.21a10.29,10.29,0,0,0-3,7.47,10.61,10.61,0,0,0,3.11,7.38A10.26,10.26,0,0,0,11.49,22a10.57,10.57,0,0,0,7.4-18.06A10.16,10.16,0,0,0,11.7,1Zm-.2,16a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,1,0v5.5A.5.5,0,0,1,11.5,17Zm-.89-9.5a.89.89,0,0,1,.89-.89h0a.89.89,0,0,1,.89.89h0a.88.88,0,0,1-.89.88h0a.88.88,0,0,1-.89-.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.57061df89da935f0059c31d9c0135e4d.svg";
export { ForwardRef as ReactComponent };